import React from 'react';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import ControlledForm from './ControlledForm';
import formFieldsPropTypes from './form-prop-types';
import UncontrolledForm from './UncontrolledForm';
import pageUtilsPropTypes from '../page/page-prop-types';

const MyForm = React.forwardRef((props, ref) => {
  const {
    fields,
    validationSchema,
    onSubmit,
    disabled,
    submitButtonLabelId,
    formType,
    pageUtils,
    repository,
    initialValues,
    defaultValues,
    isCreate,
    useSubmitButton,
    isHideOnMobile,
    inputRefs,
    icons,
  } = props;

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });

  React.useImperativeHandle(ref, () => ({
    handleSubmit() {
      return formik.handleSubmit();
    },
  }));

  const TypeForm = formType === 'controlled' ? ControlledForm : UncontrolledForm;

  return (
    <TypeForm
      pageUtils={pageUtils}
      repository={repository}
      disabled={disabled}
      defaultValues={defaultValues}
      fields={fields}
      isCreate={isCreate}
      useSubmitButton={useSubmitButton}
      isHideOnMobile={isHideOnMobile}
      submitLabelId={submitButtonLabelId}
      inputRefs={inputRefs}

      values={formik.values}
      errors={formik.errors}
      touched={formik.touched}
      handleChange={formik.handleChange}
      handleBlur={formik.handleBlur}
      handleSubmit={formik.handleSubmit}
      setFieldTouched={formik.setFieldTouched}
      setValues={formik.setValues}

      icons={icons}
    />
  );
});

MyForm.propTypes = {
  fields: PropTypes.arrayOf(formFieldsPropTypes).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  validationSchema: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  submitButtonLabelId: PropTypes.string,
  formType: PropTypes.oneOf(['controlled', 'uncontrolled']),
  pageUtils: pageUtilsPropTypes,
  repository: PropTypes.object,
  initialValues: PropTypes.object,
  defaultValues: PropTypes.object,
  isCreate: PropTypes.bool,
  useSubmitButton: PropTypes.bool,
  isHideOnMobile: PropTypes.bool,
  inputRefs: PropTypes.object,
  icons: PropTypes.objectOf(PropTypes.object).isRequired,
};

MyForm.defaultProps = {
  disabled: false,
  submitButtonLabelId: 'MyForm.button.submit',
  formType: 'controlled',
  pageUtils: undefined,
  repository: undefined,
  initialValues: {},
  defaultValues: {},
  isCreate: true,
  useSubmitButton: true,
  isHideOnMobile: false,
  inputRefs: undefined,
};

export default MyForm;
